<template>
  <div>
    <div
      class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <!-- Multi-purpose Toast Notification (NOT WORKING) -->
      <!-- :class="toastType == 'success' ? 'bg-success' : 'bg-danger'" -->
      <!-- <div
        id="toastNotification"
        :class="'toast me-3 hide bg-' + toastType"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style="position: fixed; top: 1; right: 0; z-index:1;"
      >
        <div class="toast-header">
          <strong v-if="toastType == 'success'" class="me-auto">Success!</strong>
          <strong v-else-if="toastType == 'danger'" class="me-auto">ERROR</strong>
          <strong v-else class="me-auto">Notification</strong>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body bg-light">
          {{ this.toastMessage }}
        </div>
      </div> -->

      <!-- Success Toast -->
      <div
        id="successToast"
        class="toast me-3 hide bg-success"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style="position: fixed; top: 1; right: 0; z-index:1;"
      >
        <div class="toast-header">
          <strong class="me-auto">Success</strong>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body bg-light">
          {{ this.toastMessage }}
        </div>
      </div>

      <!-- Error Toast -->
      <div
        id="errorToast"
        class="toast me-3 hide bg-danger"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style="position: fixed; top: 1; right: 0; z-index:1;"
      >
        <div class="toast-header">
          <strong class="me-auto">ERROR</strong>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
        <div class="toast-body bg-light">
          {{ this.toastMessage }}
        </div>
      </div>

      <!-- Ruleset Heading -->
      <div class="row">
        <h1 class="h2 text-muted">
          MAPPING ENGINE / RULESETS / {{ head_ruleset_name }}
        </h1>
      </div>
      <div class="row" style="justify-content: flex-end;">
        <div class="col-2">
          <button
            type="button"
            class="btn btn-danger"
            id="disbut"
            data-bs-toggle="modal"
            data-bs-target="#removeModal"
          >
            Remove Ruleset
          </button>
        </div>
        <div class="col-2">
          <button
            type="button"
            class="btn btn-primary"
            id="savebut"
            @click="editRuleset"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>

    <!-- Remove Ruleset Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Ruleset
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label">
                Are you sure you want to remove this ruleset? (Type yes to
                confirm)
              </label>
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="removeRuleset"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Errors -->
    <div
      id="alertRuleset"
      v-if="updateRulesetError"
      class="alert alert-danger"
      role="alert"
    >
      Error: {{ updateRulesetReason }}
    </div>

    <!-- Ruleset Info -->
    <form class="row g-3" @submit.prevent="editRuleset()">
      <div class="col-md-4">
        <label class="form-label">Ruleset Name</label>
        <input
          type="text"
          class="form-control"
          id="rulesetName"
          v-model="ruleset_name"
          disabled
        />
      </div>
      <div class="col-md-3">
        <label class="form-label">Calculator</label>
        <select
          class="form-select"
          id="calculatorName"
          v-model="calculator_id"
          @change="getInsurer"
          disabled
        >
          <option
            v-for="calculator in calculators"
            v-bind:value="calculator.calculator_id"
            :key="calculator.calculator_id"
          >
            {{ calculator.calculator_name }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Insurer</label>
        <select
          class="form-select"
          id="insurerName"
          v-model="insurer_id"
          disabled
          @change="getCalculators"
        >
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_id"
            :key="insurer.insurer_id"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <label>
            Active
          </label>
          <br />
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              style="margin-top: 1.2em;"
              v-model="active"
              @change="activate"
            />
          </div>
        </div>
      </div>
      <div class="col-md-1" style="align-self: flex-end;">
        <button type="button" class="btn btn-secondary" @click="enableEdit">
          Edit
        </button>
      </div>
    </form>

    <!-- Search Bar -->
    <SearchBar
      ref="SearchBar"
      class="mt-3"
      :sourcefields="rules"
      :reverseSort="reverseSort"
      filename="EditRuleset"
      defaultSearchBy="rule_type"
      @updateValuesFromSearchBar="updateValuesFromSearchBar"
    ></SearchBar>

    <!-- Top Paginator -->
    <Paginator
      ref="TopPaginator"
      :position="'top'"
      :array="rulesFiltered"
      :numberOfFields="this.rulesFiltered.length"
      :activePageNumberTemp="activePageNumber"
      :loadPerPageTemp="loadPerPage"
      :pageStart="pageStart"
      :numberOfPages="Math.ceil(this.rulesFiltered.length / this.loadPerPage)"
      :reverseSortTemp="reverseSort"
      :noResultsMessageTemp="
        !this.rules.length ? 'No Rules Have Been Added' : 'No Results'
      "
      perPageType="ruleset"
      @goToPage="goToPage"
      @itemsPerPageUpdated="itemsPerPageUpdated"
      @updateReverseSort="updateReverseSort"
    ></Paginator>

    <!-- Activate Ruleset Modal -->
    <div
      class="modal fade"
      id="activateModal"
      tabindex="-1"
      aria-labelledby="activateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Activate Ruleset</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="activated ? null : (active = false)"
            ></button>
          </div>
          <div class="modal-body" v-if="activated">
            Ruleset has been successfully activated.
          </div>
          <div class="modal-body" v-else>
            Another ruleset for this calculator and insurer is already active.
            Are you sure you want to switch?
          </div>
          <div class="modal-footer" v-if="activated">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Done
            </button>
          </div>
          <div class="modal-footer" v-else>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="active = false"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="forceActivate"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Force Update Ruleset Modal -->
    <!-- **We might be able to remove this as it doesn't seem to be used -->
    <div
      class="modal fade"
      id="forceUpdateModal"
      tabindex="-1"
      aria-labelledby="forceUpdateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Activate Ruleset</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Another ruleset for this calculator and insurer is already active.
            Are you sure you want to switch?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="
                forceActive = true;
                editRuleset();
              "
              data-bs-dismiss="modal"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Deactivate Ruleset Modal -->
    <div
      class="modal fade"
      id="deactivateModal"
      tabindex="-1"
      aria-labelledby="deactivateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Deactivate Ruleset
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Ruleset has been successfully deactivated.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Top Add Rule Button -->
    <button
      v-if="rulesFiltered.length"
      type="button"
      class="btn btn-secondary mb-3"
      @click="openAddRuleModal({}, 'End')"
    >
      Add Rule
    </button>

    <!-- Table Headers -->
    <form v-if="rulesFiltered.length" class="row g-3 px-3">
      <div class="col-md-1 ms-2"></div>
      <div class="col-md-1">
        <h6>#</h6>
      </div>
      <div class="col-md-2">
        <h6>Rule Type</h6>
      </div>
      <div class="col-md-3">
        <h6>Sources</h6>
      </div>
      <div class="col-md-3">
        <h6>Output/Result</h6>
      </div>
    </form>

    <!-- Table Content -->
    <div v-if="initialLoader" class="spinner-border text-primary" />
    <div v-else class="accordion accordion-flush" id="accordionFlushExample">
      <draggable
        v-model="filteredRules"
        ghost-class="ghost"
        @choose="onChoose"
        @end="onEnd"
        handle=".handle"
      >
        <transition-group type="transition" name="flip-list">
          <div
            class="sortable accordion-item"
            :id="rule.sort"
            v-for="(rule, index) in filteredRules"
            :key="rule.sort"
          >
            <!-- Add Rule Above -->
            <RuleEditor
              ref="AddRuleAbove"
              source="Above"
              :method="method"
              :ruleTemp="rule"
              :functionExpTemp="functionExp"
              :renderSelectedSourceFieldsTemp="renderSelectedSourceFields"
              :calculator_id="calculator_id"
              :insurer_id="insurer_id"
              :calculatorFields="calculatorFields"
              :tables="tables"
              @openChangeSourceFieldsModal="openChangeSourceFieldsModal"
              @updateExpandedFunctionExp="updateExpandedFunctionExp"
              @clearRenderSelectedSourceFields="clearRenderSelectedSourceFields"
              @updateRules="updateRules"
              @cacheData="cacheData"
              @successToast="successToast"
            ></RuleEditor>

            <div class="accordion-header" :id="'ugh' + rule.rule_id">
              <div class="d-flex">
                <div class="col-md-1" style="align-self: center;">
                  <button
                    type="button"
                    class="btn btn-light btn-sm"
                    @click="up(index)"
                    :disabled="rule.sort == 1 || $refs.SearchBar.searchString"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-chevron-compact-up"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="btn btn-light btn-sm"
                    @click="down(index)"
                    :disabled="
                      rules.indexOf(rule) == rules.length - 1 ||
                        $refs.SearchBar.searchString
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-chevron-compact-down"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"
                      />
                    </svg>
                  </button>
                </div>
                <button
                  class="accordion-button collapsed"
                  :id="'accordion-header' + rule.rule_id"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#editRule' + rule.rule_id"
                  @click="openEditRule(rule, index)"
                >
                  <div class="col-md-1" style="width: 9%;">{{ rule.sort }}</div>
                  <div class="col-md-2" style="width: 19.5%;">
                    {{ rule.rule_type }}
                  </div>
                  <div class="col-md-3" style="width: 30%;">
                    <div
                      v-for="source in rule.source_fields"
                      :key="source"
                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
                    >
                      {{ source }}
                    </div>
                  </div>
                  <div
                    v-if="rule.output_type === 'calculator'"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >
                    {{ rule.calculator_param }}
                  </div>
                  <div
                    v-else-if="rule.output_type === 'custom'"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >
                    {{ rule.custom_field }}
                  </div>
                  <div
                    v-else-if="
                      rule.rule_type === 'qualify-function' ||
                        rule.rule_type === 'qualify-lookup'
                    "
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                  >
                    {{ rule.decline_message }}
                  </div>
                </button>
                <div class="btn-group dropdown" style="align-self: center;">
                  <button
                    type="button"
                    class="btn btn-light btn-sm"
                    data-bs-toggle="dropdown"
                    :id="'btn' + rule.rule_id"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-three-dots-vertical"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                      />
                    </svg>
                  </button>
                  <ul
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="dropdownMenuButton1"
                    :id="'dropdown' + rule.rule_id"
                  >
                    <li>
                      <button
                        class="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#removeRuleModal"
                        @click="currentRuleId = rule.rule_id"
                      >
                        Remove this rule
                      </button>
                    </li>
                    <li>
                      <button
                        class="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#copyRuleModal"
                        @click="
                          getRulesets();
                          currentRuleId = rule.rule_id;
                        "
                      >
                        Copy this rule
                      </button>
                    </li>
                    <li>
                      <button
                        class="dropdown-item"
                        @click="openAddRuleModal(rule, 'Above')"
                      >
                        Insert Above
                      </button>
                    </li>
                    <li>
                      <button
                        class="dropdown-item"
                        @click="openAddRuleModal(rule, 'Below')"
                      >
                        Insert Below
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="ms-3" style="align-self: center;">
                  <font-awesome-icon
                    icon="fa-solid fa-bars"
                    :class="[
                      $refs.SearchBar.searchString ? 'move-cancel' : 'handle',
                    ]"
                  />
                </div>
              </div>
            </div>

            <!-- Edit Rule -->
            <RuleEditor
              ref="EditRule"
              source="Edit"
              :method="rule.rule_type"
              :ruleTemp="rule"
              :functionExpTemp="functionExp"
              :renderSelectedSourceFieldsTemp="renderSelectedSourceFields"
              :calculator_id="calculator_id"
              :insurer_id="insurer_id"
              :calculatorFields="calculatorFields"
              :tables="tables"
              @openChangeSourceFieldsModal="openChangeSourceFieldsModal"
              @updateExpandedFunctionExp="updateExpandedFunctionExp"
              @clearRenderSelectedSourceFields="clearRenderSelectedSourceFields"
              @updateRules="updateRules"
              @cacheData="cacheData"
              @successToast="successToast"
            ></RuleEditor>

            <!-- Add Rule Below -->
            <RuleEditor
              ref="AddRuleBelow"
              source="Below"
              :method="method"
              :ruleTemp="rule"
              :functionExpTemp="functionExp"
              :renderSelectedSourceFieldsTemp="renderSelectedSourceFields"
              :calculator_id="calculator_id"
              :insurer_id="insurer_id"
              :calculatorFields="calculatorFields"
              :tables="tables"
              @openChangeSourceFieldsModal="openChangeSourceFieldsModal"
              @updateExpandedFunctionExp="updateExpandedFunctionExp"
              @clearRenderSelectedSourceFields="clearRenderSelectedSourceFields"
              @updateRules="updateRules"
              @cacheData="cacheData"
              @successToast="successToast"
            ></RuleEditor>
          </div>
        </transition-group>
      </draggable>
    </div>

    <!-- Remove Rule Modal -->
    <div
      class="modal fade"
      id="removeRuleModal"
      tabindex="-1"
      aria-labelledby="removeRuleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Rule
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDeleteRule = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDeleteRule" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this rule? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  v-model="confirmDeleteRule"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDeleteRule = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="removeRule()"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Copy Rule Modal -->
    <div
      class="modal fade"
      id="copyRuleModal"
      tabindex="-1"
      aria-labelledby="copyRuleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              COPY RULE
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="
                copyType = '';
                copyRuleset = '';
              "
            ></button>
          </div>
          <div class="modal-body col-md-10" style="align-self: center;">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                value="start"
                v-model="copyType"
              />
              <label class="form-check-label">
                Copy to the Start of this Ruleset
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                value="end"
                v-model="copyType"
              />
              <label class="form-check-label">
                Copy to the End of this Ruleset
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                value="another"
                v-model="copyType"
              />
              <label class="form-check-label">
                Copy to another Ruleset
              </label>
            </div>
            <div v-if="copyType === 'another'" class="col-md-8">
              <select class="form-select mt-2 mb-2" v-model="copyRuleset">
                <option
                  v-for="ruleset in rulesets"
                  v-bind:value="ruleset.ruleset_id"
                  :key="ruleset.ruleset_id"
                >
                  {{ ruleset.ruleset_name }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="copyRule()"
            >
              Copy
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Expanded Function Modal -->
    <div
      class="modal fade"
      id="expandedFuncModal"
      tabindex="-1"
      aria-labelledby="expandedFuncModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              EXPANDED FUNCTION EDITOR
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <textarea
              class="form-control"
              rows="4"
              v-model="expandedFunctionExp"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="functionExp = expandedFunctionExp"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Rule End -->
    <RuleEditor
      ref="AddRuleEnd"
      source="End"
      :method="method"
      :ruleTemp="{ sort: 0, rule_id: '', source_fields: {} }"
      :functionExpTemp="functionExp"
      :renderSelectedSourceFieldsTemp="renderSelectedSourceFields"
      :calculator_id="calculator_id"
      :insurer_id="insurer_id"
      :calculatorFields="calculatorFields"
      :tables="tables"
      @openChangeSourceFieldsModal="openChangeSourceFieldsModal"
      @updateExpandedFunctionExp="updateExpandedFunctionExp"
      @clearRenderSelectedSourceFields="clearRenderSelectedSourceFields"
      @updateRules="updateRules"
      @cacheData="cacheData"
      @successToast="successToast"
    ></RuleEditor>

    <!-- Bottom Add Rule Button -->
    <button
      v-if="rulesFiltered.length"
      type="button"
      class="btn btn-secondary mb-3"
      @click="openAddRuleModal({}, 'End')"
    >
      Add Rule
    </button>

    <!-- New Add Rule Button (only shows when no rules have been added) -->
    <div class="d-flex justify-content-center mt-3">
      <button
        v-if="!rules.length"
        type="button"
        class="btn btn-success mb-3"
        @click="openAddRuleModal({}, 'End')"
      >
        Add Rule
      </button>
    </div>

    <!-- Bottom Paginator -->
    <Paginator
      id="bottomPaginator"
      :position="'bottom'"
      :array="rulesFiltered"
      :numberOfFields="this.rulesFiltered.length"
      :activePageNumberTemp="activePageNumber"
      :loadPerPageTemp="loadPerPage"
      :pageStart="pageStart"
      :numberOfPages="Math.ceil(this.rulesFiltered.length / this.loadPerPage)"
      :reverseSortTemp="reverseSort"
      perPageType="ruleset"
      @goToPage="goToPage"
      @itemsPerPageUpdated="itemsPerPageUpdated"
      @updateReverseSort="updateReverseSort"
    ></Paginator>
    <br /><br />

    <!-- Add Rule Modal -->
    <AddRuleModal
      ref="AddNewRuleModal"
      :ruleSort="modalRuleSort"
      :source="modalSource"
      @methodChanged="methodChanged"
    ></AddRuleModal>

    <!-- Change Source Fields Modal -->
    <RulesetSourcefieldModal
      ref="ChangeSourceFieldsModal"
      :sourcefields="sourcefields"
      :loadPerPageTemp="300"
      :sourceLoader="sourceLoader"
      @renderFields="renderFields"
    ></RulesetSourcefieldModal>

    <!-- Supported Functions Help Modal -->
    <div
      class="modal fade"
      id="functionsHelp"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Supported Functions Help
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Note: You can pass Numeric value or any Source Field as the inputs
            for the functions <br /><br />All the Mathematical operations {+, -,
            /, *, ^, etc} will be processed based on BODMAS rule. i.e, In Order
            of Brackets &gt; Order(Power and Exponents) &gt;
            Division/Multiplication &gt; Addition/Substraction Eg:- A+B*C+D/E
            =&gt; A+(B*C)+(D/E) <br /><br />
            ROUND(&lt;value&gt;,&lt;decimals&gt;) <br />Eg:- ROUND(15.245,2)
            =&gt; 15.25<br />
            ROUND(A,B) {A and B are the source fields}<br /><br />
            ROUNDUP(&lt;value&gt;,&lt;decimals&gt;)<br />
            Eg:- ROUNDUP(17.833,1) =&gt; 17.9<br /><br />
            ROUNDDOWN(&lt;value&gt;,&lt;decimals&gt;)<br />
            Eg:- ROUNDDOWN(45.4589,3) =&gt; 45.458<br /><br />
            POWER(&lt;value&gt;,&lt;exponent&gt;) <br />Eg:- POWER(4,3) =&gt;
            64<br />
            POWER(A,5) <br /><br />AVERAGE(&lt;value1&gt;, &lt;value2&gt; ... )
            <br />Eg:- AVERAGE(8, 4, 6) =&gt; 6<br /><br />
            MIN(&lt;value1&gt;, &lt;value2&gt; ... )<br />
            Eg:- MIN(8,5,6,45) =&gt; 5 <br /><br />MAX(&lt;value1&gt;,
            &lt;value2&gt; ... )<br />
            Eg:- MAX(A,B,C) =&gt; will return maximum value between source
            fields A,B,C.<br /><br />
            SUM(&lt;value1&gt;, &lt;value2&gt; ... )<br />
            Eg:- SUM(A,B,15) <br /><br />ABS(&lt;value&gt;) <br />Eg:-
            ABS(-45.8) =&gt; 45.8<br /><br />
            IF(&lt;condition&gt;, &lt;output in case of true&gt;, &lt;output in
            case of false&gt;)<br />
            Eg:- IF(A&lt;=8, "1-8","8") =&gt; return "1-8" for A less than equal
            to 8 and "8" for greater than "8". Where A is the Input Source Field
            <br /><br />LN(&lt;value&gt;): To calculate Natural Logarithm of a
            Number<br />
            Eg:- LN(32) =&gt; 3.4657359027997265<br /><br />
            LOG(&lt;value&gt;, &lt;base&gt;): To calculate Logarithm of a Number
            for given base.<br />
            Eg:- LOG(32,2) =&gt; 4<br /><br />
            AND(&lt;condition1&gt;, &lt;condition2&gt; ....): Performs Logical
            AND operation between different condition and return True or
            False<br />
            Eg:- AND(A&gt;5, A&lt;50) =&gt; Depends on value of a the function
            will return True or False<br /><br />
            OR(&lt;condition1&gt;, &lt;condition2&gt; ....): Performs Logical
            AND operation between different condition and return True or False
            <br />Eg:- OR(A&gt;100, A&lt;50) =&gt; Depends on value of a the
            function will return True or False
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              id="functionsHelpbtn"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Custom Table Help Modal -->
    <div
      class="modal fade"
      id="tableMapSupportModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Custom Table Help
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <ol>
              <li>
                To Direct compare the field value just place the value in the
                cell. <br />
                Eg:- This will evaluated as "tools_limit == 8" <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Table Map Images/image002.jpg"
                />
              </li>
              <li>
                In case of Not Equal To use "!=" sign in front of value. <br />
                Eg:- This will evaluated as "tools_limit != 15" i.e, tools_limit
                is not equal to 15. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Table Map Images/image004.jpg"
                />
              </li>
              <li>
                In case of range such as value between 0 and 500 use ":" sign.
                <br />
                Eg:- This will evaluated as "tools_limit >=0 and tools_limit
                &lt;=500" <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Table Map Images/image006.jpg"
                />
              </li>
              <li>
                To use logical AND condition between expression use "&amp;"
                symbol. <br />
                Eg: This will evaluated as "tools_limit > 10 and tools_limit
                &lt; 200"<br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Table Map Images/image008.jpg"
                />
              </li>
              <li>
                To use logical OR condition between expression use "|" symbol.
                <br />
                Eg: This will evaluated as "tools_limit > 10 or tools_limit ==
                5" <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Table Map Images/image010.jpg"
                />
              </li>
            </ol>
            <b>Note:</b> Their will be Logical AND operation between different
            columns in a row and Logical OR operation between rows. <br />
            Whenever a true condition appears for a row its output value is
            returned and no further comparing is done.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Qualify Function Help Modal -->
    <div
      class="modal fade"
      id="qualifyFunSupportModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Qualify Function Help
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <ol>
              <li>
                To use logical AND conditions between expressions use the
                "&amp;" symbol. <br />
                Eg:- if A=1, B=1, this will be evaluated as True and if A=0 or
                B=0, then the result is False. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image001.jpg"
                />
              </li>
              <li>
                To use logical OR condition between expression use "|" symbol.
                <br />
                Eg:- if A=0, B=0, this will be evaluated as False and if A=1 or
                B=1, then the result is True. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image002.jpg"
                />
              </li>
              <li>
                In the case of Equal To, use the "=" sign in between the values.
                <br />
                Eg:- If A=2, B=2, then this will be evaluated as True and if
                B=3, then the result is False. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image003.jpg"
                />
              </li>
              <li>
                In the case of Not Equal To, use the "!=" sign in between the
                values. <br />
                Eg:- If A=2, B=2, then this will be evaluated as False and if
                B=3, then the result is True.<br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image004.jpg"
                />
              </li>
              <li>
                In the case of Greater than, use the "&gt;" sign and Greater
                than equal to, use the "&gt;=" sign between the values.
                <br />
                Eg:- If A=4, B=6, then this will be evaluated as False and if
                A=10, then the result is True. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image005.jpg"
                />
              </li>
              <li>
                In the case of less than, use the "&lt;" sign and less than
                equal to, use the "&lt;=" sign between the values.
                <br />
                Eg:- If A=4, B=6, then this will be evaluated as True and if
                A=10, then the result is False. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image006.jpg"
                />
              </li>
              <li>
                To check if a number lies in range, use the ":" sign to define
                the range.
                <br />
                Eg:- If A=6, then this will be evaluated as True and if A=10,
                then the result is False. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image007.jpg"
                />
              </li>
              <li>
                To use a combination of more than one operation, the result will
                be evaluated from left to right.
                <br />
                Eg:- If A=600, B=400, then this will be evaluated as True and if
                A=200, then the result is False. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image008.jpg"
                />
                <br />
                Eg:- if A=8, B=12, C=12, then this will be evaluated as False
                and if C=11, then the result is True. <br />
                <img
                  class="mt-2 mb-2"
                  src="../../assets/Qualify Function Images/image009.jpg"
                />
              </li>
            </ol>
            <b>Note:</b> The final result of the expression should always be
            boolean i.e, True or False.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "../SearchBar.vue";
import Paginator from "../Paginator.vue";
import RulesetSourcefieldModal from "./Edit Ruleset/RulesetSourcefieldModal.vue";
import AddRuleModal from "./Edit Ruleset/AddRuleModal.vue";
import RuleEditor from "./Edit Ruleset/RuleEditor.vue";
import draggable from "vuedraggable";
import config from "../../config";
import _ from "lodash";
import $ from "jquery";

export default {
  data() {
    return {
      head_ruleset_name: "",
      ruleset_name: "",
      calculators: [],
      // calculator_name: "", // **might not be safe to remove, check
      calculator_id: 0,
      insurers: [],
      insurer_id: 0,
      sourcefields: [],
      confirmDelete: "",
      rules: [],
      active: false,
      activated: false,
      fieldValues: {},
      method: "",
      calculatorFields: [],
      renderSelectedSourceFields: [],
      confirmDeleteRule: "",
      functionExp: "",
      expandedFunctionExp: "",
      copyType: "",
      copyRuleset: "",
      rulesets: [],
      tableMap: {},
      tables: [],
      updateRulesetError: false,
      updateRulesetReason: "",
      forceActive: false,
      initialLoader: true,
      sourceLoader: null, // remove later once component has been transferred
      stringMatch: [],
      // For AddRuleModal
      modalRuleSort: 0,
      modalSource: "",
      // For Rules
      rulesFiltered: {},
      pageStart: 0,
      loadPerPage: 25,
      activePageNumber: 1,
      reverseSort: "false",
      reversed: false,
      // For RuleEditor
      rule: {},
      currentRuleId: "",
      // Customizable messages for success toast
      toastMessage: null,
      // For draggable/sortable rules
      oldIndex: null,
      newIndex: null,
    };
  },
  components: {
    SearchBar,
    Paginator,
    RulesetSourcefieldModal,
    AddRuleModal,
    RuleEditor,
    draggable,
  },
  watch: {
    reverseSort() {
      this.checkReverseRulesFiltered();
    },
    // Calls SearchBar filter every time rules gets updated
    rules() {
      if (
        this.$refs.SearchBar.sourcefieldsFiltered.length &&
        this.$refs.SearchBar.searchString
      ) {
        this.$refs.SearchBar.searchStringUpdated(true);
      }
    },
  },
  computed: {
    filteredRules: {
      // Returns the list to be displayed
      get() {
        return this.rulesFiltered.slice(
          this.pageStart,
          this.pageStart + this.loadPerPage
        );
      },
      set() {
        return this.rulesFiltered.slice(
          this.pageStart,
          this.pageStart + this.loadPerPage
        );
      },
    },
  },
  methods: {
    // Runs every time rules/rulesFiltered is reset OR when reverseSort is changed from the paginator component
    checkReverseRulesFiltered() {
      // reverseSort is what the sorting needs to be (string)
      // reversed is what the array currently is (boolean)
      if (this.reverseSort === "true" && !this.reversed) {
        this.rulesFiltered.reverse();
        this.reversed = true;
      } else if (this.reverseSort == "false" && this.reversed) {
        this.rulesFiltered.reverse();
        this.reversed = false;
      }
    },
    // For draggable
    onChoose: function() {
      $(".collapse").collapse("hide");
    },
    onEnd: function(evt) {
      this.oldIndex = evt.oldIndex;
      this.newIndex = evt.newIndex;
      if (this.oldIndex != this.newIndex) {
        this.moveRule();
      }
    },
    async moveRule() {
      var data, i, error;
      // Move rule up
      for (i = 0; i < Math.abs(this.oldIndex - this.newIndex); i++) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: this.$route.params.id,
              swap_list: [
                // If this.newIndex < this.oldIndex, then we're moving the rule up
                // Otherwise, we're moving the rule down and need to make a slightly different computation (subtract i instead of add)
                this.newIndex < this.oldIndex
                  ? {
                      rule_id: this.rules[
                        this.newIndex +
                          i +
                          (this.activePageNumber - 1) * this.loadPerPage
                      ].rule_id,
                      sort: this.rules[
                        this.newIndex +
                          i +
                          (this.activePageNumber - 1) * this.loadPerPage
                      ].sort,
                    }
                  : {
                      rule_id: this.rules[
                        this.newIndex -
                          i +
                          (this.activePageNumber - 1) * this.loadPerPage
                      ].rule_id,
                      sort: this.rules[
                        this.newIndex -
                          i +
                          (this.activePageNumber - 1) * this.loadPerPage
                      ].sort,
                    },
                {
                  rule_id: this.rules[
                    this.oldIndex +
                      (this.activePageNumber - 1) * this.loadPerPage
                  ].rule_id,
                  sort: this.rules[
                    this.oldIndex +
                      (this.activePageNumber - 1) * this.loadPerPage
                  ].sort,
                },
              ],
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/swap_rules_sort",
          requestOptions
        );
        data = await response.json();
        if (data.reason == "Cannot be swapped") {
          error = true;
          break;
        }
        this.rules = data.rules;
        this.rules.forEach((element) => {
          element.source_fields = Object.values(element.source_fields);
        });
      }
      if (error == true) {
        this.errorToast(
          "The move operation was canceled due to an error.\nThis may cause the rules to be in an incorrect order."
        );
      } else {
        this.successToast("Rule moved.");
        this.rulesFiltered = this.rules;
        this.reversed = false;
        this.checkReverseRulesFiltered();
      }
    },
    // **todo: merge toast functions
    successToast(message) {
      this.toastMessage = message;
      $("#errorToast").toast("hide");
      $("#successToast").toast("show");
    },
    errorToast(message) {
      this.toastMessage = message;
      $("#successToast").toast("hide");
      $("#errorToast").toast("show");
    },
    // From RuleEditor
    updateRules(newRules) {
      this.$refs.TopPaginator.noRulesAdded = true;
      this.rules = newRules;
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      sessionStorage.setItem("rules", JSON.stringify(newRules));
    },
    updateExpandedFunctionExp(newExpandedFunctionExp) {
      this.expandedFunctionExp = newExpandedFunctionExp;
    },
    clearRenderSelectedSourceFields() {
      this.renderSelectedSourceFields = [];
    },
    // For AddRuleModal
    methodChanged(newMethod) {
      if (!this.rules.length) {
        this.$refs.TopPaginator.noRulesAdded = false;
      }
      this.method = newMethod;
      if (this.modalSource === "End") {
        this.jumpToBottom("bottom");
      }
    },
    // To open RulesetSourcefieldModal
    openChangeSourceFieldsModal: function(sourceFields) {
      this.getSourceFields();
      this.$refs.ChangeSourceFieldsModal.open(sourceFields);
    },
    // To open RuleEditor
    openEditRule: function(rule, index) {
      this.rule = rule;
      this.trial(rule.rule_id, rule.sort);
      // console.log("rule", rule);
      this.$refs.EditRule[index].initializeValues(
        this.tableMap,
        this.fieldValues,
        this.stringMatch,
        rule.source_fields
      );
    },
    // To open AddRuleModal
    openAddRuleModal: function(rule, source) {
      $(".collapse").collapse("hide");
      this.$refs.AddRuleEnd.clear();
      this.rule = rule;
      this.functionExp = "";
      // console.log("rule", rule);
      if (source != "End") {
        // **get rid of this and replace it with modalRule = {sort: 0, rule_id: ''}
        // Since the "End" id doesn't need modalRuleSort (the id of the element in the list)
        this.modalRuleSort = rule.sort;
      }
      this.modalSource = source;
      this.trial(0, 0);
      this.$refs.ChangeSourceFieldsModal.resetSelectedSourceFields();
      this.$refs.AddNewRuleModal.open();
    },
    // For Paginator
    goToPage(newActivePageNumber, newPageStart, position) {
      this.activePageNumber = newActivePageNumber;
      this.pageStart = newPageStart;
      this.jumpToBottom(position);
    },
    itemsPerPageUpdated(
      newActivePageNumber,
      newPageStart,
      newLoadPerPage,
      position
    ) {
      this.activePageNumber = newActivePageNumber;
      this.pageStart = newPageStart;
      this.loadPerPage = newLoadPerPage;
      this.jumpToBottom(position);
    },
    updateReverseSort(newReverseSort, position) {
      this.reverseSort = newReverseSort;
      this.jumpToBottom(position);
    },
    jumpToBottom(position) {
      if (position == "bottom") {
        var element = document.getElementById("bottomPaginator");
        _.delay(function() {
          element.scrollIntoView();
        }, 0);
      }
    },
    // For SearchBar
    updateValuesFromSearchBar(newRulesFiltered, reset) {
      // SearchBar component calculates the new filtered array, pageStart, and pageNumber where pageStart and pageNumber are either left alone or reset to 0 and 1 respectively
      this.rulesFiltered = newRulesFiltered;
      // Don't need to set reversed to false since the search bar doesn't get ruleFiltered from the database and so doens't reverse the array (it gets the array from rulesFiltered)
      this.checkReverseRulesFiltered();
      if (reset) {
        this.pageStart = 0;
        this.activePageNumber = 1;
      }
    },
    renderFields(newSelectedSourceFields) {
      this.renderSelectedSourceFields = newSelectedSourceFields;
      const l = new Set(this.renderSelectedSourceFields);
      for (let prop of Object.keys(this.fieldValues)) {
        if (!l.has(prop)) {
          delete this.fieldValues[prop];
        }
      }
      Object.values(this.tableMap).forEach(function(row) {
        for (let prop of Object.keys(row)) {
          if (!l.has(prop) && prop != "output") {
            delete row[prop];
          }
        }
      });
    },
    trial(rule_id, sort) {
      // **todo: see if trial can be entirely moved to RuleEditor and rename method
      let nl = document.querySelectorAll('[id^="accordion-header"]');
      var arr = [];
      for (var i = nl.length; i--; arr.unshift(nl[i].id));
      arr.forEach((element) => {
        $("#" + element).css({ visibility: "visible", height: "auto" });
      });
      this.getDeets();
      this.fieldValues = {};
      this.stringMatch = [];
      if (rule_id !== 0 && sort !== 0) {
        if ("test_values" in this.rules[sort - 1]["rule_data"]) {
          this.fieldValues = Object.assign(
            {},
            this.rules[sort - 1]["rule_data"]["test_values"]
          );
        }
        if ("string_match" in this.rules[sort - 1]["rule_data"]) {
          this.stringMatch = this.rules[sort - 1]["rule_data"]["string_match"];
        }
        $("#addRuleEnd").collapse("hide");
        $("#editRule" + rule_id).collapse("show");
        if (this.rules[sort - 1].rule_type === "map") {
          this.tableMap = _.cloneDeep(this.rules[sort - 1].rule_data.table_map);
        }
      }
    },
    async copyRule() {
      var rulesetId = null;
      if (this.copyType === "start" || this.copyType === "start") {
        rulesetId = this.$route.params.id;
      } else if (this.copyType === "another") {
        rulesetId = this.copyRuleset;
      }
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            rule_id: this.currentRuleId,
            ruleset_id: rulesetId,
            copy_type: this.copyType,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/copy_rule",
        requestOptions
      );
      const data = await response.json();
      // console.log(data);
      if (
        (this.copyType !== "another" && data["Added"]) ||
        (this.copyType === "another" &&
          data["Added"] &&
          rulesetId == this.$route.params.id)
      ) {
        this.rules = data["rules"];
      }
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
      if (data["Added"]) this.successToast("Rule copied.");
      this.copyType = "";
      this.copyRuleset = "";
      this.cacheData();
    },
    async removeRule() {
      if (this.confirmDeleteRule.toLowerCase() === "yes") {
        this.successToast("Rule removed.");
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              rule_id: this.currentRuleId,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_rule",
          requestOptions
        );
        const data = await response.json();
        // console.log(data);
        this.rules = data["rules"];
        this.rules.forEach((element) => {
          element.source_fields = Object.values(element.source_fields);
        });
        sessionStorage.setItem("rules", JSON.stringify(data["rules"]));
        this.confirmDeleteRule = "";
      } else {
        this.confirmDeleteRule = "";
      }
      this.cacheData();
    },
    async removeRuleset() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: parseInt(this.$route.params.id),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_ruleset",
          requestOptions
        );
        const data = await response.json();
        if (data["Completed"]) this.$router.push("/rulesets");
      } else {
        this.confirmDelete = "";
      }
    },
    async down(index) {
      $(".collapse").collapse("hide");
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            swap_list: [
              {
                rule_id: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index
                ].rule_id,
                sort: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index
                ].sort,
              },
              {
                rule_id: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index + 1
                ].rule_id,
                sort: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index + 1
                ].sort,
              },
            ],
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/swap_rules_sort",
        requestOptions
      );
      const data = await response.json();
      // console.log("data", data);
      this.rules = data.rules;
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      this.rulesFiltered = this.rules;
      this.reversed = false;
      this.checkReverseRulesFiltered();
      this.successToast("Rule moved down.");
    },
    async up(index) {
      $(".collapse").collapse("hide");
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            swap_list: [
              {
                rule_id: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index - 1
                ].rule_id,
                sort: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index - 1
                ].sort,
              },
              {
                rule_id: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index
                ].rule_id,
                sort: this.rules[
                  this.loadPerPage * (this.activePageNumber - 1) + index
                ].sort,
              },
            ],
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/swap_rules_sort",
        requestOptions
      );
      const data = await response.json();
      // console.log("data", data);
      this.rules = data.rules;
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      this.rulesFiltered = this.rules;
      this.reversed = false;
      this.checkReverseRulesFiltered();
      this.successToast("Rule moved up.");
    },
    async activate() {
      if (this.active) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: this.$route.params.id,
              calculator_id: this.calculator_id,
              insurer_id: this.insurer_id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/activate_ruleset",
          requestOptions
        );
        const data = await response.json();
        if (data["Activated"]) this.activated = true;
        $("#activateModal").modal("show");
      } else {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              ruleset_id: this.$route.params.id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/deactivate_ruleset",
          requestOptions
        );
        const data = await response.json();
        if (data["Deactivated"]) $("#deactivateModal").modal("show");
      }
    },
    async forceActivate() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/force_activate_ruleset",
        requestOptions
      );
      const data = await response.json();
      if (data["Activated"]) {
        this.activated = true;
        $("#activateModal").modal("show");
      }
    },
    enableEdit() {
      $("#rulesetName").removeAttr("disabled");
      $("#calculatorName").removeAttr("disabled");
      $("#insurerName").removeAttr("disabled");
    },
    async editRuleset() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
            ruleset_name: this.ruleset_name,
            calculator_id: this.calculator_id,
            insurer_id: this.insurer_id,
            force_active: this.forceActive,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_ruleset",
        requestOptions
      );
      const data = await response.json();
      // console.log(data);
      if (data["Added"]) this.$router.push("/rulesets");
      else {
        if (data["reason"].includes("active")) {
          $("#forceUpdateModal").modal("show");
        } else {
          this.updateRulesetError = true;
          this.updateRulesetReason = data["reason"];
        }
      }
    },
    async getRulesets() {
      const response = await fetch(config.baseURL + "/get_rulesets", {
        credentials: "include",
      });
      const data = await response.json();
      // console.log(data);
      this.rulesets = data;
    },
    async getSourceFields() {
      this.sourceLoader = true;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_all_req_calculated_fields",
        requestOptions
      );
      const data = await response.json();
      let sourceFields = JSON.parse(
        sessionStorage.getItem("req_quotey_fields")
      );
      sourceFields.push(...data);
      this.sourcefields = sourceFields;
      this.sourceLoader = false;
    },
    async getInsurer() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            calculator_id: this.calculator_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_calculator",
        requestOptions
      );
      const data = await response.json();
      this.insurer_id = data["calculator_details"]["insurer_id"];
    },
    async getDeets() {
      let data = JSON.parse(sessionStorage.getItem("ruleset_details"));
      this.head_ruleset_name = data["ruleset_name"];
      this.ruleset_name = data["ruleset_name"];
      this.calculator_name = data["calculator_name"];
      this.calculator_id = data["calculator_id"];
      this.insurer_name = data["insurer_name"];
      this.insurer_id = data["insurer_id"];
      this.active = data["active"];
      this.calculatorFields = JSON.parse(
        sessionStorage.getItem("calculator_params")
      );
      this.tables = JSON.parse(
        sessionStorage.getItem("get_lookup_tables_using_insurer")
      );
      this.initialLoader = false;
    },
    async getCalculators() {
      this.calculator_id = null;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.insurer_id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_calculator_using_insurer",
        requestOptions
      );
      const data = await response.json();
      this.calculators = data;
    },
    async getInitialCalculators() {
      const cres = await fetch(config.baseURL + "/get_calculators", {
        credentials: "include",
      });
      const cdata = await cres.json();
      this.calculators = cdata;
    },
    async getInitialInsurers() {
      const ires = await fetch(config.baseURL + "/get_insurers", {
        credentials: "include",
      });
      const idata = await ires.json();
      this.insurers = idata;
    },
    async cacheData() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_ruleset",
        requestOptions
      );
      const data = await response.json();
      if (!data["Accepted"]) this.$router.push("/error");
      this.head_ruleset_name = data["ruleset_details"]["ruleset_name"];
      this.ruleset_name = data["ruleset_details"]["ruleset_name"];
      this.calculator_name = data["ruleset_details"]["calculator_name"];
      this.calculator_id = data["ruleset_details"]["calculator_id"];
      this.insurer_name = data["ruleset_details"]["insurer_name"];
      this.insurer_id = data["ruleset_details"]["insurer_id"];
      this.active = data["ruleset_details"]["active"];
      this.rules = data["rules"];
      this.rules.forEach((element) => {
        element.source_fields = Object.values(element.source_fields);
      });
      this.rulesFiltered = this.rules;
      this.reversed = false;
      this.checkReverseRulesFiltered();
      sessionStorage.setItem(
        "ruleset_details",
        JSON.stringify(data["ruleset_details"])
      );
      sessionStorage.setItem("rules", JSON.stringify(data["rules"]));

      const fres = await fetch(
        config.baseURL + data["ruleset_details"]["params_route"]
      );
      const fdata = await fres.json();
      this.calculatorFields = fdata;
      sessionStorage.setItem("calculator_params", JSON.stringify(fdata));

      const requestOptions1 = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_id: this.insurer_id,
          },
        }),
      };
      const lres = await fetch(
        config.baseURL + "/get_lookup_tables_using_insurer",
        requestOptions1
      );
      const ldata = await lres.json();
      this.tables = ldata;
      sessionStorage.setItem(
        "get_lookup_tables_using_insurer",
        JSON.stringify(ldata)
      );

      const requestOptions2 = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            ruleset_id: this.$route.params.id,
          },
        }),
      };
      const qres = await fetch(
        config.baseURL + "/get_all_req_quotey_fields",
        requestOptions2
      );
      const qdata = await qres.json();
      // console.log(qdata);
      sessionStorage.setItem("req_quotey_fields", JSON.stringify(qdata));
      this.initialLoader = false;
    },
  },
  mounted() {
    this.cacheData();
    this.getInitialCalculators();
    this.getInitialInsurers();
  },
};
</script>

<style scoped>
.accordion-button::after {
  display: none;
}
.spinner-border {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}

/* For draggable */
.sortable {
  width: 100%;
  background: white;
}

.handle {
  cursor: move;
}

.move-cancel {
  cursor: not-allowed !important;
  color: rgb(152, 152, 152) !important;
}

.sortable-drag {
  /* To remove hover ghost display */
  opacity: 0;
}

.flip-list-move {
  transition: transform 0.5s;
}

.ghost {
  border-left: 6px solid rgb(0, 183, 255);
  opacity: 0.7;
  /* box-shadow: 10px 10px 5px -1px rgba(0, 0, 0, 0.14); */
}
</style>
